import { _ } from '~/actions/triggers/generalNotification';

export const getUserNotificationStyles = (iterator: number) => `
  .${_}notification-${iterator} .${_}input-wrapper {
    display: inline-flex;
    border: 1px solid #dbdbdb;
    border-radius: 6px;
    transition: border-color 200ms ease;
    position: relative;
    overflow: hidden;
    align-items: stretch;
    vertical-align: top;
    background-color: white;
    flex-shrink: 0;
    width: 100%;
    margin-bottom: 12px;
  }

  .${_}notification-${iterator} .${_}input-wrapper:hover._with-interaction:not(._highlighted) {
    border: 1px solid #808080;
  }

  .${_}notification-${iterator} .${_}input-wrapper._disabled {
    pointer-events: none;
    background-color: #fafafa;
    color: #ccc;
  }

  .${_}notification-${iterator} .${_}input-wrapper._without-bottom-radius {
    border-radius: 6px 6px 0 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper._without-border {
    border: none;
    border-radius: 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper._highlighted {
    color: white;
    background-color: #00bd7e;
    border: 1px solid #00bd7e;
  }

  .${_}notification-${iterator} .${_}input-wrapper._highlighted._disabled {
    background-color: #fafafa;
    color: #ccc;
    border: 1px solid #dbdbdb;
  }

  .${_}notification-${iterator} .${_}input-wrapper._block {
    display: flex;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-small {
    min-height: 32px;
    border-radius: 4px;
    padding: 0 16px 0 16px;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-small._without-bottom-radius {
    border-radius: 4px 4px 0 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-small._without-padding {
    padding: 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-small._without-border {
    border: none;
    border-radius: 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-small._elem-after {
    padding: 0 8px 0 16px;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-small._elem-after .input-wrapper__after {
    margin-left: 8px;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-default {
    min-height: 40px;
    padding: 0 16px 0 16px;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-default._without-padding {
    padding: 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-default._without-border {
    border: none;
    border-radius: 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-default._elem-after {
    padding: 0 12px 0 16px;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-default._elem-after .input-wrapper__after {
    margin-left: 12px;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-large {
    min-height: 48px;
    padding: 0 18px 0 24px;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-large._without-padding {
    padding: 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper._size-large._without-border {
    border: none;
    border-radius: 0;
  }

  .${_}notification-${iterator} .${_}input-wrapper__placeholder {
    position: absolute;
    color: #b3b3b3;
    font-size: 16px;
    /* height: 20px;
    top: 50%; */
    line-height: 20px;
    transform: translate3d(0, -10px, 0);
    transition-property: transform, font-size;
    transition-timing-function: ease;
    transition-duration: 200ms;
  }

  .${_}notification-${iterator} .${_}input-wrapper__body {
    position: relative;
    flex-grow: 1;
    line-height: 1;
  }

  .${_}notification-${iterator} .input-wrapper__after,
  .${_}notification-${iterator} .input-wrapper__before {
    display: flex;
    width: 24px;
    align-items: center;
    flex-shrink: 0;
  }

  .${_}notification-${iterator} .input-wrapper__after {
    margin-left: 18px;
  }

  .${_}notification-${iterator} .input-wrapper__after.${_}input-wrapper._size-default {
    margin-left: 12px;
  }

  .${_}notification-${iterator} .input-wrapper__before {
    margin-right: 8px;
  }

  .${_}notification-${iterator} .input-wrapper__success-icon {
    width: 24px;
    height: 24px;
    color: #00bd7e;
  }

  .${_}notification-${iterator} .${_}input-wrapper._failure:not(._highlighted) {
    border-color: #ef546b;
  }

  .${_}notification-${iterator} .${_}input-wrapper._active:not(._highlighted) {
    border-color: #000;
    z-index: 1;
  }

  .${_}notification-${iterator} .${_}input-wrapper._active:not(._highlighted)._size-small .${_}input-wrapper__placeholder {
    font-size: 12px;
    transform: translate3d(0, -20px, 0);
  }

  .${_}notification-${iterator} .${_}input-wrapper._active:not(._highlighted)._size-default .${_}input-wrapper__placeholder {
    transform: translate3d(0, -15px, 0);
  }

  .${_}notification-${iterator} .${_}input-wrapper._active:not(._highlighted)._size-large .${_}input-wrapper__placeholder {
    transform: translate3d(0, -15px, 0);
  }

  .${_}notification-${iterator} .${_}input-wrapper._active:not(._highlighted)._size-x-large .${_}input-wrapper__placeholder {
    transform: translate3d(0, -15px, 0);
  }

  .${_}notification-${iterator} .${_}input__element {
    outline: none;
    border: none;
    box-shadow: none;
    height: 100%;
    width: 100%;
    display: block;
    padding: 0;
    background-color: transparent;
    color: black;
  }

  .${_}notification-${iterator} .${_}input__element::placeholder {
    color: #b3b3b3;
  }

  .${_}notification-${iterator} .${_}input__element:disabled {
    background-color: transparent;
  }

  .${_}notification-${iterator} .${_}input._size-small .${_}input__element {
    font-size: 14px;
    line-height: 20px;
  }

  .${_}notification-${iterator} .${_}input._size-default .${_}input__element {
    font-size: 14px;
    line-height: 20px;
  }

  .${_}notification-${iterator} .${_}input._size-large .${_}input__element {
    font-size: 14px;
    line-height: 20px;
  }

  .${_}notification-${iterator} .${_}input._block .${_}input__element {
    width: 100%;
  }

  .${_}notification-${iterator} .${_}checkbox__input {
    cursor: pointer;
    margin-right: 12px;
    height: 18px;
    width: 18px;
    opacity: 0;
  }

  .${_}notification-${iterator} .${_}checkbox__label {
    display: flex;
    cursor: pointer;
    position: relative;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    user-select: none;
    letter-spacing: -.02em;
    color: #4d4d4d;
    outline: none;
  }

  .${_}notification-${iterator} .${_}checkbox__label:focus .${_}checkbox__square {
    box-shadow: 0 0 0 4px rgba(0, 123, 255, .3);
    border-color: #000;
    background-color: #000;
  }

  .${_}notification-${iterator} .${_}checkbox__label::before {
    content: "";
    display: none;
    width: 32px;
    height: 32px;
    position: absolute;
    left: -8px;
    top: -4px;
    background: #e6e6e6;
    box-sizing: border-box;
    border-radius: 10px;
    pointer-events: none;
    z-index: 0;
  }

  .${_}notification-${iterator} .${_}checkbox__svg {
    color: white;
  }

  .${_}notification-${iterator} .${_}checkbox__square {
    content: "";
    display: inline-block;
    width: 18px;
    height: 18px;
    position: absolute;
    left: -1px;
    top: 3px;
    border: 1px solid #808080;
    box-sizing: border-box;
    border-radius: 6px;
  }

  .${_}notification-${iterator} .${_}checkbox__square._failure {
    border: 1px solid #ef546b;
  }

  .${_}notification-${iterator} .${_}checkbox__icon {
    position: absolute;
    width: 18px;
    height: 18px;
    top: 3px;
    left: -1px;
    display: none;
  }

  .${_}notification-${iterator} .${_}checkbox__label:active .${_}checkbox__square {
    border-color: #ccc;
    background-color: #ccc;
  }

  .${_}notification-${iterator} .${_}checkbox__label:active::before {
    display: inline-block;
  }

  .${_}notification-${iterator} .${_}checkbox__label:active .${_}checkbox__icon {
    display: inline-block;
  }

  .${_}notification-${iterator} .${_}checkbox__label:active .${_}checkbox__icon .${_}checkbox__svg {
    color: white;
  }

  .${_}notification-${iterator} .${_}checkbox__label:hover::before {
    display: inline-block;
  }

  .${_}notification-${iterator} .${_}checkbox._checked .${_}checkbox__square {
    background-color: #000;
    border-color: #000;
  }

  .${_}notification-${iterator} .${_}checkbox._checked .${_}checkbox__icon {
    display: inline-block;
  }

  .${_}notification-${iterator} .${_}checkbox._checked .${_}checkbox__icon svg.${_}checkbox__svg {
    color: white !important;
    width: 18px !important;
    height: 18px !important;
  }

  .${_}notification-${iterator} .${_}checkbox._disabled._checked {
    pointer-events: none;
  }

  .${_}notification-${iterator} .${_}checkbox._disabled._checked .${_}checkbox__label {
    color: #ccc;
  }

  .${_}notification-${iterator} .${_}checkbox._disabled._checked .${_}checkbox__square {
    border-color: #ccc;
    background-color: #ccc;
  }

  .${_}notification-${iterator} .${_}checkbox._disabled:not(._checked) {
    pointer-events: none;
  }

  .${_}notification-${iterator} .${_}checkbox._disabled:not(._checked) .${_}checkbox__label {
    color: #ccc;
  }

  .${_}notification-${iterator} .${_}checkbox._disabled:not(._checked) .${_}checkbox__square {
    border-color: #ccc;
  }

  .${_}notification-${iterator} .${_}checkbox._disabled:not(._checked)._checked .${_}checkbox__square {
    border: 1px solid #ccc;
    background-color: white;
  }

  .${_}notification-${iterator} .${_}checkbox._size-small .${_}checkbox__input {
    height: 16px;
    width: 16px;
    min-width: 16px;
    margin-right: 8px;
  }

  .${_}notification-${iterator} .${_}checkbox._size-small .${_}checkbox__square {
    height: 16px;
    width: 16px;
    left: -1px;
    top: 4px;
  }

  .${_}notification-${iterator} .${_}checkbox._size-small .${_}checkbox__label::before {
    width: 26px;
    height: 26px;
    left: -6px;
    top: -1px;
    border-radius: 8px;
  }

  .${_}notification-${iterator} .${_}checkbox._size-small .${_}checkbox__label:active .${_}checkbox__square {
    border: 4px solid #ccc;
  }

  .${_}notification-${iterator} .${_}checkbox._size-small .${_}checkbox__label:active::before {
    display: inline-block;
    width: 26px;
    height: 26px;
    left: -6px;
    top: -1px;
  }

  .${_}notification-${iterator} .${_}checkbox._size-small .${_}checkbox__icon {
    left: -2px;
  }

  .${_}notification-${iterator} .${_}checkbox._size-small._disabled._checked .${_}checkbox__square {
    border-color: #ccc;
    background-color: #ccc;
  }

  .${_}notification-${iterator} .${_}icon {
    display: block;
  }

  .${_}notification-${iterator} .${_}notification__box .${_}notification__privacy-policy {
    margin-top: 12px;
  }

  .${_}notification-${iterator} .${_}notification__box .${_}checkbox__text {
    font-family: Inter;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.03em;
    margin-top: 5px;
    color: white;
  }

  .${_}notification-${iterator} .${_}notification__box .${_}notification__privacy-policy-link {
    text-decoration: underline;
    color: white;
  }

   .${_}notification-${iterator}.${_}adaptation__element {
    align-items: start !important;
    justify-content: center !important;
    overflow-y: auto;
  }

  .${_}notification-${iterator} .${_}notification__box.${_}adaptation__box {
    position: relative;
    left: 0;
    top: 0;
    transform: none !important;
    justify-content: center !important;
    margin: 10px auto;
    max-width: 97%;
  }
`;
